import {NgModule} from '@angular/core';
import {DffTextareaComponent} from './dff-textarea.component';
import {DynamicFormComponent} from './dynamic-form.component';
import {DffCommonComponent} from './dff-common.component';
import {CommonModule} from '@angular/common';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FormsModule} from '@angular/forms';
import {DffInputComponent} from './dff-input.component';
import {AutocompleteOptionComponent} from './autocomplete-option.component';
import {DffCheckboxComponent} from './dff-checkbox.component';
import {DffCheckboxGroupComponent} from './dff-checkbox-group.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {DffDateAndTimeComponent} from './dff-date-and-time.component';
import {CheckboxModule} from './checkbox/checkbox.module';
import {TranslateModule} from '@ngx-translate/core';
import {DffPeriodComponent} from './dff-period.component';
import {MatInputModule} from '@angular/material/input';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {DffRadioButtonGroupComponent} from './dff-radio-button-group.component';
import {MatRadioModule} from '@angular/material/radio';
import {DffSelectComponent} from './dff-select.component';
import {MatSelectModule} from '@angular/material/select';
import {DffFileUploadComponent} from './dff-file-upload.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatIconModule} from '@angular/material/icon';
import {DffBusinessObjectComponent} from './dff-business-object.component';
import {BoInstanceSelectorComponent} from './bo-instance-selector/bo-instance-selector.component';
import {MultipleComponent} from './bo-instance-selector/multiple.component';
import {TableComponent} from './bo-instance-selector/table.component';
import {BoFieldsComponent} from './bo-instance-selector/bo-fields.component';
import {CustomRadioButtonModule} from './custom-radio-button/custom-radio-button.module';
import {PopoverModule} from '@greetgo/popover';
import {CreateBoiOverlayComponent} from './bo-instance-selector/create-boi-overlay.component';
import {DffTabGroupComponent} from './dff-tab-group.component';
import {NzDatePickerModule} from 'ng-zorro-antd/date-picker';
import {NzTimePickerModule} from 'ng-zorro-antd/time-picker';
import {QuillModule} from 'ngx-quill';

const dff = [
  DffTextareaComponent,
  DffInputComponent,
  DffCheckboxComponent,
  DffCheckboxGroupComponent,
  DffDateAndTimeComponent,
  DffPeriodComponent,
  DffRadioButtonGroupComponent,
  DffSelectComponent,
  DffFileUploadComponent,
  DffBusinessObjectComponent,
  DffTabGroupComponent,
];

@NgModule({
  declarations: [
    DynamicFormComponent,
    DffCommonComponent,
    AutocompleteOptionComponent,
    BoInstanceSelectorComponent,
    MultipleComponent,
    TableComponent,
    BoFieldsComponent,
    CreateBoiOverlayComponent,
    ...dff,
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatCheckboxModule,
    CheckboxModule,
    NzDatePickerModule,
    NzTimePickerModule,
    TranslateModule,
    MatInputModule,
    MatDatepickerModule,
    MatRadioModule,
    MatSelectModule,
    MatProgressBarModule,
    MatIconModule,
    PopoverModule,
    CustomRadioButtonModule,
    QuillModule,
  ],
  exports: [
    DynamicFormComponent,
    BoInstanceSelectorComponent,
  ],
  entryComponents: [
    ...dff
  ]
})
export class DynamicFormsModule {}
